import { Navigate, useParams } from "react-router-dom";
import OnboardingIntegrations from "../platforms/Onboarding/Integrations";

const VALID_SOURCES = ["note-taker", "team-communication"];

export default function SourceGuard() {
  const { source } = useParams();

  if (!VALID_SOURCES.includes(source)) {
    return <Navigate to="/404" replace />;
  }

  return <OnboardingIntegrations />;
}
